import React, { useEffect, useRef, useState } from 'react';
import './style.scss';
import { Form, Input, Modal, Popconfirm, Radio } from 'antd';
import { MoreOutlined } from '@ant-design/icons';
import barcode from 'assets/imgs/VinaphonePlus/barcode.png';
import qrCodeIcon from 'assets/imgs/VinaphonePlus/qr-code-icon.png';
import ButtonVplus from '../../../../../../components/ButtonVplus/ButtonVplus';
import { 
  loyalty_card, 
  loyalty_card_back, 
  silver_card, 
  silver_card_back, 
  gold_card, 
  gold_card_back, 
  titan_card, 
  titan_card_back, 
  diamond_card, 
  diamond_card_back 
} from "assets/imgs/VinaphonePlus";

import { QRCodeSVG } from 'qrcode.react';
import Barcode from 'react-barcode';
import { shield_success, shield_fail } from 'assets/icons/VinaphonePlus';
import OTPVplus from 'pages/VinaphonePlusNew/components/OTPVplus/OTPVplus';
import { VPlusService } from 'services/VPlusService';
import { v4 as uuidv4 } from 'uuid';
import { Notification } from 'components';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { UserService } from 'services/UserService';
import { LIST_VNPP_TITLE_LOGOUT, PATH } from 'pages/Header/Header';
import { useDispatch } from 'react-redux';
import { doGetUserInfoVplus, doGetUserPromoMenu, doLogout, doLogoutVplus, doTokenDevVplus, doTokenHoiVienEscVplus, doTokenHoiVienVplus } from 'store/action/userAction';
import {LoyaltyService} from "../../../../../../../../services/LoyaltyService";

const listCards = [
  {
    rankCode: "VNP_KIMCUONG",
    HangHoiVienId: 1,
    frontImg: diamond_card,
    backImg: diamond_card_back
  },
  {
    rankCode: "VNP_VANG",
    HangHoiVienId: 2,
    frontImg: gold_card,
    backImg: gold_card_back
  },
  {
    rankCode: "VNP_TITAN",
    HangHoiVienId: 3,
    frontImg: titan_card,
    backImg: titan_card_back
  },
  {
    rankCode: "VNP_BAC",
    HangHoiVienId: 4,
    frontImg: silver_card,
    backImg: silver_card_back
  },
  {
    rankCode: "VNP_THANTHIET",
    HangHoiVienId: 5,
    frontImg: loyalty_card,
    backImg: loyalty_card_back
  },
]

const MembershipCardModalVplus = ({ isVisible, userInfo, phoneNumber, handleOk, handleCancel, ...rest }) => {
  const history = useHistory()
  const dispatch = useDispatch();
  const uuid = useRef(uuidv4()).current;
  const [isModalReson, setIsModalReson] = useState(false);
  const [isModalResult, setIsModalResult] = useState(false);
  const [isFlipped, setIsFlipped] = useState(false);
  // const [selectedValue, setSelectedValue] = useState(1);
  const [tempValue, setTempValue] = useState(1);
  const [isModalOTP, setIsModalOTP] = useState(false);
  const [isOtpError, setIsOtpError] = useState(false);
  const [isCancelSuccess, setIsCancelSuccess] = useState(false);
  const [messageErrorCancelMember, setMessageErrorCancelMember] = useState();

  const isLoyalty = localStorage?.getItem("flowType") === "Loyalty";
  const currentCard = listCards.find(item => isLoyalty ? item?.rankCode === userInfo?.rankCode : item?.HangHoiVienId === userInfo?.HangHoiVienMoiId);
  const [otpId, setOtpId] = useState("");

  const handleChange = e => {
    setTempValue(e.target.value);
  };

  const handleImageClick = () => {
    setIsFlipped(!isFlipped);
  };

  const handleCancelMembership = () => {
    handleCancel();
    setIsModalReson(true);
  };

  const handleSetMessageErrorCancelMember = (message, isSuccess = false) => {
    setMessageErrorCancelMember(message);
    setIsModalResult(true);
    setIsCancelSuccess(isSuccess);
  }

  const handleConfirmCancelMembership = async () => {
    setIsModalReson(false);
    if (isLoyalty) {
      const payload = {
        cancelReason: "huy",
        requestId: uuid,
        otpId: "",
        otpValue: ""
      }
      await cancelMember(payload);
    } else {
      const payload = {
        otpValue: "",
        maMayUuid: uuid,
        maHeDieuHanh: "WEB",
      }
      await apiCancelMember(payload);
    }
  }


  const handleVerifyOTP = async (otp) => {
    if (isLoyalty) {
      const payload = {
        cancelReason: "huy",
        requestId: uuid,
        otpId: otpId,
        otpValue: otp
      }
      await cancelMember(payload);
    } else {
      const payload = {
        otpValue: otp,
        maMayUuid: uuid,
        maHeDieuHanh: "WEB",
      }
      await apiCancelMember(payload)
    }
  };

  const handleResendOTP = async () => {
    setIsModalReson(false);
    if (isLoyalty) {
      const payload = {
        cancelReason: "huy",
        requestId: uuid,
        otpId: "",
        otpValue: ""
      }
      await cancelMember(payload);
    } else {
      const payload = {
        otpValue: "",
        maMayUuid: uuid,
        maHeDieuHanh: "WEB",
      }
      await apiCancelMember(payload);
    }
  };

  const cancelMember = async (payload) => {
    try {
      await LoyaltyService.cancelMember(payload, res => {
        switch (res?.errorCode) {
          case "100":
            //Gửi OTP Thành công
            setOtpId(res?.data);
            Notification.success(res?.message);
            setIsModalOTP(true);
            break;

          case "0":
            // Hủy hội viên thành công
            handleSetMessageErrorCancelMember(res?.message, true);
            handleCancelModalOTP();
            break;

          case "wrong_otp":
          case "101":
          case "102":
          case "103":
          case "104":
          case "105":
          case "106":
          case "107":
            Notification.error(res?.message);
            setIsOtpError(true);
            break;

            // case "14":
            //   // Hủy hội viên thất bại
            //   Notification.error(res?.message);
            //   handleCancelModalOTP();
            //   history.push('/');
            //   break;

          case "042":
            handleSetMessageErrorCancelMember((res?.message ? res?.message : "") + `<br>Tài khoản bạn đã bị khóa do thực hiện hủy quá số lần cho phép.<br>Bạn vui lòng thử lại sau ít phút hoặc liên hệ Tổng đài 1800 1091 để được hỗ trợ.<br>Mã hỗ trợ: ${res?.errorCode}`);
            handleCancelModalOTP();
            break;

          case "400":
          case "04":
          case "14":
          case "28":
            handleSetMessageErrorCancelMember((res?.message ? res?.message : "") + "<br>Tạm thời không thực hiện được.<br>" + "Bạn vui lòng thử lại sau ít phút hoặc liên hệ Tổng đài 1800 1091 để được hỗ trợ.<br>" + `Mã hỗ trợ: ${res?.errorCode}`);
            handleCancelModalOTP();
            break;
          default:
            handleSetMessageErrorCancelMember(res?.message);
            handleCancelModalOTP();
            break;
        }
      });
    } catch (error) {
      Notification.error('Lỗi hệ thống. Chúng tôi đã ghi nhận và sẽ khắc phục sớm.');
    }
  };

  const apiCancelMember = async (payload) => {
    try {
      VPlusService.apiCancelMember(payload, res => {
        switch (res?.errorCode) {
          case "16":
            //Mã xác thực hết hạn
            Notification.error(res?.message);
            setIsOtpError(true);
            break;
          case "17":
            //Gửi OTP Thành công
            Notification.success(res?.message);
            setIsModalOTP(true);
            break;
          case "0":
            // Hủy hội viên thành công
            handleSetMessageErrorCancelMember(res?.message, true);
            handleCancelModalOTP();
            break;
          case "20":
            // sai OTP
            Notification.error(res?.message);
            setIsOtpError(true);
            break;
          case "14":
            // Hủy hội viên thất bại
            Notification.error(res?.message);
            handleCancelModalOTP();
            history.push('/');
            break;
          default:
            handleSetMessageErrorCancelMember(res?.message);
            handleCancelModalOTP();
            break;
        }
      });
    } catch (error) {
      Notification.error('Lỗi hệ thống. Chúng tôi đã ghi nhận và sẽ khắc phục sớm.');
    }
  };
  
  const handleCancelModalOTP = () => {
    setIsModalOTP(false);
    setIsOtpError(false);
  }

  const handleLogOut = () => {
    const data = {
      msisdn: localStorage.getItem('mobile'),
    };

    UserService.logout(data, res => {
      if (res.error_code === '0') {
        dispatch(doLogout());
        dispatch(doLogoutVplus());
        localStorage.clear();
        dispatch(doTokenDevVplus(""));
        dispatch(doTokenHoiVienEscVplus(""));
        dispatch(doTokenHoiVienVplus(""));
        dispatch(doGetUserInfoVplus(undefined));
        dispatch(doGetUserPromoMenu(LIST_VNPP_TITLE_LOGOUT));
        // Notification.success("Đăng xuất thành công");
        history.push('/');
      } else {
        Notification.error("Có lỗi xảy ra!");
      }
    }, () => {
      Notification.error("Có lỗi xảy ra!");
    });
  }

  const handleCancelOk = () => {
    if(isCancelSuccess) {
      setIsModalResult(false);
      handleLogOut();
    } else {
      setIsModalResult(false);
      history.push('/');
    }
  }
  return (
    <>
      <Modal
        title={null}
        className="modal-membership-custom"
        open={isVisible}
        footer={null}
        width={576}
        {...rest}
        maskClosable={false}
        onCancel={handleCancel}
      >
        <div className="modal-membership">
  
          <div className="modal-membership-header">
            <div className="membership-header-text">Thông tin thẻ hội viên</div>
            {/* <Popconfirm
              placement="right"
              title={<>
                <div className="custom-title">Hủy hội viên</div>
                <div className="custom-des">Bạn có chắc chắn muốn hủy bỏ hội viện?</div>
              </>}
              icon={null}
              okText="Đồng ý"
              cancelText="Đóng"
              overlayClassName="membership-header-popconfirm"
              onConfirm={() => {
                setIsModalReson(true) 
                handleCancel()
              }}
            >
              <MoreOutlined className="membership-header-icon" />
            </Popconfirm> */}
          </div>

          <div className="modal-membership-body">
            <div className="modal-membership-card" onClick={handleImageClick}>
              <div className={`flip-container ${isFlipped ? 'flipped' : ''}`}>
                <div className="flipper">
                  <div className="front">
                    <img className="membership-card-img" src={currentCard?.frontImg} alt="Front Image"/>
                    <div className={`membership-card-text`}>
                      <div className="card-text-name" style={{color: currentCard?.HangHoiVienId === 4 ? "#000" : "#FFF"}}>{isLoyalty ? userInfo?.name : userInfo?.TenHoiVien}</div>
                      <div className="card-text-phone" style={{color: currentCard?.HangHoiVienId === 4 ? "#000" : "#FFF"}}>{phoneNumber}</div>
                    </div>
                  </div>

                  <div className="back">
                    <img className="membership-card-img" src={currentCard?.backImg} alt="Back Image" />
                    {/* <div className={`membership-card-text`}>
                      <div>• Quý khách vui lòng xuất trình thẻ này khi sử dụng dịch vụ.</div>
                      <div>• Thẻ có giá trị khi hạng hiện tại của Quý khách tương ứng với hạng ghi trên thẻ.</div>
                      <div>• Thẻ này thuộc quyền sở hữu của VinaPhone. Việc sử dụng thẻ phải tuân thủ các quy định và chính sách do VinaPhone ban hành.</div>
                      <div>• Please present this card when using service.</div>
                      <div>• This card is valid when your current class in VinaPhone Plus system and the class printed on this card is the same.</div>
                      <div>• This card is the property of VinaPhone. The use of this card is governed by regulations and policies issued by VinaPhone.</div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-membership-item">
              <div className="modal-membership-qr">
                {tempValue === 1 ? (
                  <QRCodeSVG className='detail' value={isLoyalty ? userInfo?.memberCard : userInfo?.SoTheHoiVienVinaPhonePlus} width={156} height={156}/>
                ) : (
                  <Barcode value={isLoyalty ? userInfo?.memberCard : userInfo?.SoTheHoiVienVinaPhonePlus}/>
                )}
              </div>
              <Radio.Group className="modal-membership-radio" onChange={handleChange} value={tempValue}>
                <Radio value={1}>
                  <img src={qrCodeIcon} alt="" />
                </Radio>
                <Radio value={2}>
                  <img src={barcode} alt="" />
                </Radio>
              </Radio.Group>
            </div>
          </div>
          {localStorage.getItem("off_net") == 0 && (
            <div className="modal-membership-btn">
              <ButtonVplus className="border-custom" borderColor="#FF5040" onClick={handleCancelMembership}>Huỷ hội viên</ButtonVplus>
              {/* <ButtonVplus className="normal" onClick={handleOkMembership}>Xác nhận</ButtonVplus> */}
            </div>
          )}
        </div>
      </Modal>
  
      <Modal
        title="Hủy Hội viên VinaPhone Plus"
        className="modal-vplus"
        open={isModalReson}
        onOk={handleOk}
        footer={null}
        onCancel={() => setIsModalReson(false)}
      >
        <div className="modal-membership-reson">
          <div className="modal-membership-reson-content">
            <div className="modal-membership-reson-txt">Bạn sẽ bị huỷ toàn bộ số điểm và hạng Hội viên hiện có. Sau 48h bạn mới có thể được đăng ký lại.</div>
            <br/>
            <div className="modal-membership-reson-txt">Nếu bạn huỷ hội viên 03 lần trong vòng 12 tháng bạn sẽ bị khoá tài khoản hội viên.</div>
            <br/>
            <div className="modal-membership-reson-txt">Sau 12 tháng kể từ khi bị khoá tài khoản Hội viên, bạn mới được đăng ký lại.</div>
          </div>
          <div className="btn-gr">
            <ButtonVplus className="border-custom" borderColor="#FF5040" onClick={handleConfirmCancelMembership}>Xác nhận hủy</ButtonVplus>
            <ButtonVplus className="membership-reson-skip-btn" onClick={() => setIsModalReson(false)}>Bỏ qua</ButtonVplus>
          </div>
        </div>
      </Modal>

      <Modal
        title={isCancelSuccess ? "Thông báo" : "Chưa thể huỷ hội viên"}
        className="modal-vplus"
        open={isModalResult}
        onOk={handleOk}
        footer={null}
        onCancel={handleCancelOk}
      >
        <div className="modal-membership-result">
          <div className="modal-membership-result-content">
            <div className="modal-membership-result-txt">
              {isCancelSuccess ? (
                "Huỷ hội viên VinaPhone Plus thành công."
              ) : (
                <div dangerouslySetInnerHTML={{
                  __html: messageErrorCancelMember
                }}></div>
              )}
            </div>
          </div>
          <ButtonVplus className="border-custom" borderColor={isCancelSuccess ? "#3079FF" : "#FF5040"} onClick={handleCancelOk}>
            <img src={isCancelSuccess ? shield_success : shield_fail} /> Tôi đã hiểu
          </ButtonVplus>
        </div>
      </Modal>

      <OTPVplus
        visible={isModalOTP}
        onVerify={handleVerifyOTP}
        onResend={handleResendOTP}
        onCancel={() => setIsModalOTP(false)}
        phoneNumber={localStorage.getItem('mobile') ? `0${localStorage.getItem('mobile')?.slice(2)}` : ''}
        isResend={true}
        isOtpError={isOtpError}
        setIsOtpError={setIsOtpError}
        isCheckOffNet={true}
        timeLeft={180}
      />
    </>
  )
};

export default React.memo(MembershipCardModalVplus);